import { captureSignupOnboardingSource } from '../stores/signup-flow-store';
import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { createSignupApi } from '../services/signup-api/select';
import type { SignupApi } from '../services/signup-api/signup-api';

/**
 * The signup flow's data seam for the current page. One instance per scenario,
 * so the local fake keeps its click-through state across re-renders. Must
 * render under a Suspense boundary (Next's `useSearchParams` contract).
 */
export function useSignupApi(): SignupApi {
  const scenarioParam = useSearchParams().get('scenario');
  return useMemo(
    () =>
      createSignupApi({ scenarioParam, captureOnboardingSource: captureSignupOnboardingSource }),
    [scenarioParam],
  );
}
